import React, { useContext, useLayoutEffect } from "react";
import { GrigoraDashboardContext } from "../dashboard/context";
import { Link } from "react-router-dom";
import "./pills.scss";

function Pills({ options = [], isActive, setIsActive, hasOutlet = false }) {
  const { projectID, activeScreen } = useContext(GrigoraDashboardContext) || {};

  useLayoutEffect(() => {
    // Make buttons of equal width
    var buttons = document.querySelectorAll(".pill-btn");
    var maxWidth = 0;
    buttons.forEach((button) => {
      if (button.offsetWidth > maxWidth) {
        maxWidth = button.offsetWidth;
      }
    });
    buttons.forEach((button) => {
      button.style.minWidth = `${maxWidth}px`;
    });
  }, []);

  return (
    <>
      {options.map((option, index) => {
        if (option?.hide === true) return null;
        return option?.path ? (
          <Link
            to={`${
              hasOutlet ? `/site/${projectID}/${option?.path}` : option?.path
            }`}
            target={option?.openLinkInNewTab ? "_blank" : undefined}
            key={`pill-${option}-${index}`}
            className={`pill-btn ${
              activeScreen === option?.path ? "active" : ""
            }`}
          >
            {option?.label}
          </Link>
        ) : (
          <button
            key={`pill-${option}-${index}`}
            onClick={(e) => setIsActive(option?.key)}
            className={`pill-btn ${isActive === option?.key ? "active" : ""}`}
          >
            {option?.label}
          </button>
        );
      })}
    </>
  );
}

export default Pills;
